export const about = {
  // Hero
  heroTitle: 'About Dynamix',
  heroSubtitle: 'Leading the future of concrete reinforcement with innovative steel fiber solutions.',
  
  // Our Story
  storyTitle: 'Our Story',
  storyP1: 'DYNAMIX is an innovative brand in the production of high-performance steel fiber wire for reinforced concrete structures. Established to offer engineering-focused solutions to the evolving needs of the construction industry, Dynamix stands out with its products that enhance durability, provide ease of application, and standardize quality.',
  storyP2: 'Based in Çorlu, Tekirdağ, we are bringing a new breath to the construction industry with our commitment to innovation, quality, and structural integrity. Our state-of-the-art manufacturing facility combines advanced technology with expert craftsmanship to produce steel fibers that meet the most demanding international standards.',
  storyP3: 'We carry the trace of our engineering in every steel fiber and the foundation of trust in every project.',
  
  // Mission & Vision
  missionTitle: 'Our Mission',
  missionDesc: 'To provide innovative, high-quality steel fiber solutions that enhance the durability and safety of concrete structures worldwide. We integrate quality not only into our product but also into our processes with the principles of sustainability and transparency.',
  
  visionTitle: 'Our Vision',
  visionDesc: 'To extend the lifespan of structures, reduce labor costs, and add value to the industry in concrete reinforcement technologies. We aim to be the global leader in steel fiber innovation, setting new standards for quality and performance.',
  
  // Core Values
  valuesTitle: 'Our Core Values',
  valuesSubtitle: 'The principles that guide everything we do.',
  
  value1Title: 'Quality Excellence',
  value1Desc: 'Uncompromising commitment to the highest manufacturing standards and product quality.',
  
  value2Title: 'Innovation',
  value2Desc: 'Continuous research and development to advance concrete reinforcement technology.',
  
  value3Title: 'Integrity',
  value3Desc: 'Transparent business practices and honest relationships with all stakeholders.',
  
  value4Title: 'Sustainability',
  value4Desc: 'Environmental responsibility in manufacturing and promoting durable construction solutions.',
  
  // Why Choose Us
  whyTitle: 'Why Choose Dynamix',
  whySubtitle: 'What sets us apart in the steel fiber industry.',
  
  why1Title: 'Expert Team',
  why1Desc: 'Our experienced engineers and technicians bring decades of combined expertise in concrete reinforcement technology and materials science.',
  
  why2Title: 'Modern Infrastructure',
  why2Desc: 'State-of-the-art manufacturing facility equipped with advanced production technology and quality control systems.',
  
  why3Title: 'International Standards',
  why3Desc: 'All products manufactured in compliance with ASTM A820 and other international standards for steel fiber reinforcement.',
  
  why4Title: 'Technical Support',
  why4Desc: 'Comprehensive technical assistance from project planning through execution, ensuring optimal fiber selection and application.',
  
  why5Title: 'Reliable Delivery',
  why5Desc: 'Efficient logistics and inventory management ensure timely delivery to keep your construction projects on schedule.',
  
  why6Title: 'Customer Focus',
  why6Desc: 'Dedicated to understanding and meeting the unique requirements of each project with customized solutions.',
  
  // CTA
  ctaTitle: 'Partner with Dynamix',
  ctaSubtitle: 'Join the growing number of construction professionals who trust Dynamix for their steel fiber reinforcement needs.',
};
